// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"462":"994eae17","631":"bd36c364","782":"02e10a3e","821":"ec200526","866":"ec200526","938":"aab59340","973":"ec200526"}[chunkId] + ".chunk.css";
};